<template>
  <section class="mt-2 d-md-flex justify-content-center flex-wrap">
    <div class="row w-1200 mb-4">    
      <div class="col-12 col-lg-6 mb-2">
        <h1>Buscador gratuito de parecidos de {{ network_selected.text }}</h1>
        <p class="avenir-medium">Cultivar la sinergia perfecta entre la marca y el creador es más arte que suerte. Por cada creador que resuena con el espíritu de tu marca, es posible que te hayas encontrado con varios que no dieron en el blanco. Reconocer que cada creador aporta un estilo distinto y que no todos son los embajadores adecuados para su marca, es crucial.</p>
        <p class="avenir-medium mb-3">Nuestra herramienta similar, que utiliza métricas de tus creadores destacados, está aquí para amplificar las fortalezas de tu programa de influencers. ¡Sumérgete a continuación!</p>

        <div>
          <strong>Cuenta</strong>
          <div class="position-relative">
            <b-spinner
              v-if="loading"
              variant="primary"
              class="loading-suggestioner-input"
            />
            <feather-icon @click="user = ''; user_selected = null" icon="XIcon" v-if="!loading && (user.length > 0 || user_selected)" class="x-suggestioner-input"></feather-icon>

            <commponent
              :is="vue_autosuggest"
              v-model="user"
              :suggestions="filteredOptions"
              :input-props="inputProps"
              :limit="10"
              @input="handleInput"
              @click="resetQuery"
              @selected="selectInfluencer"
              :get-suggestion-value="getSuggestionValue"
              class="cursor-pointer mb-1"
              ref="inputSearch"
              :should-render-suggestions="shouldRenderSuggestions"
            >
              <template slot-scope="{suggestion}">
                <chat-contact
                    class="p-0"
                    :padding_component="'p-0'"
                    :user="suggestion.item"
                    tag="li"
                    is-chat-contact
                  />
              </template>
              <template slot="before-suggestions">
                <div 
                  class="m-1"
                  v-if="user !== ''"
                >
                  {{$t('search.searchingBy')}}: {{user}}
                </div>
                <hr class="m-0" v-if="user !== ''">
              </template>
              <template slot="before-suggestions">
                <div 
                  class="m-1"
                  v-if="no_suggestions"
                >
                {{$t('lists.noresults')}} {{user}}

                </div>
              </template>
            </commponent>
          </div>
          <b-button class="w-100 blue-button h-52" variant="blue-button" :disabled="!user_selected || loading_service_results" @click="getDataForTable()">
            <span v-if="!loading_service_results">Encuentra los dobles de tu creador</span>
            <b-spinner v-else></b-spinner>
          </b-button>
        </div>
      </div>
      <div class="col-12 col-lg-6 mb-4">
        <div v-if="data_table.length === 0">
          <h5>Ejemplo</h5>
          <b-img :src="require('@/assets/images/image-example-table-alike-transformed.png')" class="w-100 table-responsive"></b-img>
        </div>
        <div v-else class="d-flex flex-column align-items-center">
          <b-table
            :fields="$t('freeToolsAlike')"
            :items="data_table"
            id="table-searcher-free-tool"
            head-variant="light"
            ref="table_searcher"
            responsive
          >
            <template #cell(name)="data">
              <div class="d-flex align-items-center justify-content-between">
                <b-media vertical-align="center" @click="redirectInnerNet(data.item.basic.username)" class="cursor-pointer">
                  <template #aside>
                    <div style="position: relative">
                      <b-avatar
                        size="40px"
                        :src="data.item.basic.avatar_url"
                        variant="light-primary"
                      />
                    </div>
                  </template>
                  <div class="d-flex flex-column justify-content-center media-container-avatar">
                    <span class="d-flex align-items-center full-name-influencer-hover avenir-medium">
                      {{ data.item.basic.fullname }} <image-verified v-if="data.item.basic.is_verified" class="ml-05"/>
                    </span>
                    <span v-if="data.item.basic.username" class="avenir-light d-block text-nowrap mb-0 text-muted-username">
                      @{{ data.item.basic.username }}
                    </span>
                  </div>
                </b-media>
              </div>
            </template>
            <template #cell(followers)="data">
              <p class="avenir-medium d-block text-nowrap mb-0">
                {{ data.item.total_subscribers ? getFormat(data.item.total_subscribers) : '0' }}
              </p>
            </template>
            <template #cell(er)="data">
              <p class="avenir-medium d-block text-nowrap mb-0">
                {{ data.item.metrics.er.value ? data.item.metrics.er.value.toFixed(2) : 0 }} %
              </p>
            </template>
            
            <template #cell(categories)="data">
              <div class="h-16 position-relative" v-if="data.item.categories">
                <span class="avatar-categories">
                {{ data.item.categories.first_category }}
                </span>
              </div>
            </template>
          </b-table>
          <b-button class="blue-button" variant="blue-button" @click.once="$router.push({name: 'auth-register'})">Regístrate GRATIS para ver 10 resultados más</b-button>
        </div>
      </div>

      <div class="col-12">
        <h2 class="">Buscar parecidos en otras plataformas</h2>
        <p class="avenir-medium">Seleccione la red social para el que desea encontrar parecidos</p>
        <strong class="d-block w-100 mb-03">Plataformas</strong>

        <b-button-group class="body-button-center mr-1">
          <b-button
            v-for="net in networks"
            :key="net.value"
            :class="network_selected.src !== net.src ? 'button-outline-header-grid-no-active' : 'button-outline-header-grid-active'"
            :variant="network_selected.src !== net.src ? 'button-outline-header-grid-no-active' : 'button-outline-header-grid-active'" 
            class="d-flex align-items-center"
            @click="network_selected = net"
          >
            <b-avatar class="size-16-icons">
              <b-img :src="getIconWhite(net.value)" :class="getIconColor(net.value, false)" fluid></b-img>
            </b-avatar>
            {{ net.text }}
          </b-button>
           
        </b-button-group>
      </div>
    </div>
  </section>
</template>

<script>
import { 
  BButton,
  BButtonGroup,
  BAvatar,
  BImg,
  BTable,
  BMedia,
  BSpinner,
} from 'bootstrap-vue'
import { getIconColor, getIconWhite } from '@/libs/utils/icons';
import { getFormat, trimText } from '@/libs/utils/formats';
import searcher_services from '@/services/search';
import config from '@/services/config'
const toast_notification = () => import('@core/components/toastification/ToastificationContent.vue')

export default {
  name: 'LookalikeInfluencers',
  components: {
    BButtonGroup,
    BButton,
    BAvatar,
    BImg,
    BSpinner,
    BTable,
    BMedia,
    ImageVerified: () => import('@/views/components/image/ImageVerified.vue'),
    ChatContact: () => import('@/views/apps/chat/ChatContact.vue'),
  },
  data() {
    return {
      getIconWhite,
      getIconColor,
      getFormat,
      networks: [
        { value: 'instagram', text: 'Instagram', src: 'ig'},
        { value: 'youtube', text: 'YouTube',  src: 'yt'},
        { value: 'tiktok', text: 'TikTok',  src: 'tt'},
      ],
      network_selected: { value: 'instagram', text: 'Instagram', src: 'ig'},
      user: '',
      user_selected: null,
      filteredOptions: [],
      inputProps: {
        id: 'autosuggest__input',
        class: 'form-control',
        placeholder: '',
      },
      typingTimer: null,
      no_suggestions: false,
      axios: null,
      vue_autosuggest: null,
      cancel: null,
      data_table: [],    
      total_categories_service: null,
      local: window.location.origin,
      loading: false,
      loading_service_results: false,
    }
  },

  created() {
    this.inputProps.placeholder = this.network_selected.src === 'yt' ? 'Introduce el canal de YouTube' : `Introduce una cuenta de ${this.network_selected.text}`
    this.getCategories()
  },
  async mounted() {
    this.axios = (await import('axios')).default;
    this.vue_autosuggest = (await import('vue-autosuggest')).VueAutosuggest
  },
  methods: {
    formatData(influencers) {
      const data = [];
      influencers.forEach(i => {
        delete i.type
        const obj = {
          type: this.network_selected.value,
          title: i.full_name,
          subscribers_count: i.followers_count,
          ...i
        }
        data.push(obj)
      })
      return data
    },
    formatDataTable(influencers) {
      influencers.forEach(i => {
        i.categories =  this.getCategoriesLabel(i.features.blogger_thematics)
      })
      return influencers;
    },
    getResultsSuggestion() {
      this.filteredOptions = []
      this.no_suggestions = false;
      if (this.user !== '') {
        this.loading = true;
        const CancelToken = this.axios.CancelToken;

        if (this.cancel) this.cancel()

        const self = this;
        this.axios({
          method: 'post',
          url: `${config.urlPhp}/api/v2/sugerencias/influencers`,
          data: {
            query: trimText(this.user),
            network: this.network_selected.src,
          },
          headers: {
            'brandme-key': process.env.VUE_APP_BRANDME_KEY,
          },
          cancelToken: new CancelToken(function executor(c) {
            self.cancel = c;
          })
        })
          .then((res) => {
            self.filteredOptions = [{data: this.formatData(res.data.data)}]
            self.no_suggestions = res.data.data.length === 0
            self.loading = false;
          })
          .catch(error => {
            if (this.axios.isCancel(error)) {
              console.log('');
            } else {
              self.no_suggestions = true;
              self.loading = false;
            }
          });
      }
    },
    resetQuery() {
      if (this.query === '') {
        this.inputProps.class = 'form-control'
        this.filteredOptions = []
      }
    },
    shouldRenderSuggestions(size, loading) {
      return size >= 0 && !loading
    },
    getSuggestionValue(suggestion) {
      return suggestion.item.username
    },
    selectInfluencer(info) {
      this.user_selected = info.item;
    },
    handleInput() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(this.getResultsSuggestion, 300);
    },
    getDataForTable() {
      this.loading_service_results = true;
      
      // FOR GETTING PROVITIONAL DATA INSTEAD USE WS LIMITED
      // eslint-disable-next-line no-constant-condition
      // if (true) {
      //   this.data_table = this.formatDataTable([{"id":45978,"look_alike":{"total_score":75,"rec_relation":"crishorwang"},"my_network":false,"basic":{"avatar_url":"https://cdn.hypeauditor.com/img/instagram/user/17148708.jpg?w=150&till=1718056800&sign=d385fca5e3f08ec5aa29f4fdf5969250","fullname":"minpechaya","is_verified":true,"description":"work : 099-621-5423, 081-867-0190","username":"minpechaya","social_id":"17148708","social_type":1,"report_state":"READY","id":null},"is_visited":false,"is_locked":true,"features":{"aqs":null,"blogger_geo":{"data":{"city":"Rome","state":"Latium","country":"Italy"}},"blogger_mentions":{"data":[54784900,2346274628,18555131,33787131,33739297843,17496055,270218054,20941946,1436839963,189666397,8010787963,8390211229,13203898238,1507916216,1692882568]},"blogger_social_networks":{"data":[1,3]},"search_content":[],"last_media":["https://cdn.hypeauditor.com/img/instagram/post/3367468201041882195.jpg?w=480&till=1722470340&sign=9e77126dea4d8184bd540b7cac1e8ec0","https://cdn.hypeauditor.com/img/instagram/post/3363129618542052864.jpg?w=480&till=1722470340&sign=17d0882f442e818150f4e363cac4df08","https://cdn.hypeauditor.com/img/instagram/post/3357356618437698354.jpg?w=480&till=1722470340&sign=243c6f54d2dded4c32eda131af9e3d0d","https://cdn.hypeauditor.com/img/instagram/post/3355216621672665210.jpg?w=480&till=1722470340&sign=6b9429b3bbd9e6255dfe0229d6e57f26"],"blogger_thematics":[1032],"lock":["aqs"]},"metrics":{"comments_avg":{"value":111},"likes_avg":{"value":35935},"subscribers_count":{"value":7009435},"real_subscribers_count":null,"er":{"value":0.513458,"mark":"average"},"subscribers_growth_prc":null},"total_subscribers":12899807},{"id":177860,"look_alike":{"total_score":75,"rec_relation":"crishorwang"},"my_network":false,"basic":{"avatar_url":"https://cdn.hypeauditor.com/img/instagram/user/2301760.jpg?w=150&till=1718056800&sign=965ea5cdf4a8cea11c56b5253228baeb","fullname":"TJ","is_verified":true,"description":"Work inquiry:\n(@)toeyforwork\n👉🏻 @toeyjarin.official\n🌏 @eecthailand","username":"toeyjarinporn","social_id":"2301760","social_type":1,"report_state":"READY","id":null},"is_visited":false,"is_locked":true,"features":{"aqs":null,"blogger_geo":{"data":{"city":"Bangkok","state":"Bangkok","country":"Thailand"}},"blogger_mentions":{"data":[6029736487,305083839,421613602,10746971331,45179981095,54533249450,304662892,4560660,373878978,3265363,3567677,228217984,9213261,550072490,816251811,32819019126]},"blogger_social_networks":{"data":[1,3,5,2]},"search_content":[],"last_media":["https://cdn.hypeauditor.com/img/instagram/post/3384908399094909982.jpg?w=480&till=1722470340&sign=80cc8228755c33367ee320bfae04d862","https://cdn.hypeauditor.com/img/instagram/post/3384379357378781238.jpg?w=480&till=1722470340&sign=a2c355f2829d3ddc2db429fe219ae014","https://cdn.hypeauditor.com/img/instagram/post/3382722136212326645.jpg?w=480&till=1722470340&sign=66ac1c32f7e5bbc2e9a1cfdca2e09405","https://cdn.hypeauditor.com/img/instagram/post/3381354150464135542.jpg?w=480&till=1722470340&sign=c8ec6df681c7b35e0d538b7bf3c97dc7"],"blogger_thematics":[1042],"lock":["aqs"]},"metrics":{"comments_avg":{"value":89},"likes_avg":{"value":82770},"subscribers_count":{"value":7938920},"real_subscribers_count":null,"er":{"value":1.043146,"mark":"average"},"subscribers_growth_prc":null},"total_subscribers":10344925},{"id":154984,"look_alike":{"total_score":74,"rec_relation":"crishorwang"},"my_network":false,"basic":{"avatar_url":"https://cdn.hypeauditor.com/img/instagram/user/6098775.jpg?w=150&till=1718056800&sign=20e5f5e89317e70f339f27aeefbc26b9","fullname":"P","is_verified":true,"description":"🤳🏻089 855 9219\n for work LINE@ K.แม่อ๋อม (click link 👇🏻)\n🐈‍⬛🐈@jiewjien_thecat\n🎞️ @second.tonone","username":"pimtha","social_id":"6098775","social_type":1,"report_state":"READY","id":null},"is_visited":false,"is_locked":true,"features":{"aqs":null,"blogger_geo":{"data":{"city":"Fukuoka","state":"Fukuoka","country":"Japan"}},"blogger_mentions":{"data":[257571174,272168048,183748231,317828866,33963262528,1249677208,45228458,30307915104,1507921835,5699634399,432756313,7114229,10904609097,690618864]},"blogger_social_networks":{"data":[1]},"search_content":[],"last_media":["https://cdn.hypeauditor.com/img/instagram/post/3387342871769663945.jpg?w=480&till=1722470340&sign=1bc52fcc49c5f56079429c1b10450cd1","https://cdn.hypeauditor.com/img/instagram/post/3387027027348995306.jpg?w=480&till=1722470340&sign=5c7c424ec2ec164eb972b3434bbfcde9","https://cdn.hypeauditor.com/img/instagram/post/3386541047303218565.jpg?w=480&till=1722470340&sign=c52cd12290cb3e118c7a8b5898d45ecb","https://cdn.hypeauditor.com/img/instagram/post/3385908276910272088.jpg?w=480&till=1722470340&sign=fb9672ed27e01050507131c17e34e0a5"],"blogger_thematics":[1021],"lock":["aqs"]},"metrics":{"comments_avg":{"value":37},"likes_avg":{"value":137618},"subscribers_count":{"value":4777495},"real_subscribers_count":null,"er":{"value":2.880934,"mark":"good"},"subscribers_growth_prc":null},"total_subscribers":4777495},{"id":1763,"look_alike":{"total_score":74,"rec_relation":"crishorwang"},"my_network":false,"basic":{"avatar_url":"https://cdn.hypeauditor.com/img/instagram/user/14191865.jpg?w=150&till=1718056800&sign=5f83f38cae37330b84c0ebb5ba0bfe23","fullname":"baifernbah","is_verified":true,"description":"Baifern Pimchanok Luevisadpaibul.\nContact for work.\n+6696-851-8199\nPlease click the link below. 🔽","username":"baifernbah","social_id":"14191865","social_type":1,"report_state":"READY","id":null},"is_visited":false,"is_locked":true,"features":{"aqs":null,"blogger_geo":{"data":{"country":"Thailand"}},"blogger_mentions":{"data":[1365173940,3321030,550072490,17364067,1445769528,1990094,191248433,39694014438,17669057,1889387,192104378,57171321578,3270451010]},"blogger_social_networks":{"data":[1]},"search_content":[],"last_media":["https://cdn.hypeauditor.com/img/instagram/post/3387119912340089406.jpg?w=480&till=1722470340&sign=4b1dc801e2eab3b779c14ed8c8037a08","https://cdn.hypeauditor.com/img/instagram/post/3385912893857641201.jpg?w=480&till=1722470340&sign=23d69d95f6ae61af18e84242d60f1b7e","https://cdn.hypeauditor.com/img/instagram/post/3385904792678135181.jpg?w=480&till=1722470340&sign=72c091f4254b2b08452ef4bc0aab7f67","https://cdn.hypeauditor.com/img/instagram/post/3385754160107964813.jpg?w=480&till=1722470340&sign=c16c94a4c1fa2d3254c7cd8eb1d4859e"],"blogger_thematics":[1032,1042],"lock":["aqs"]},"metrics":{"comments_avg":{"value":132},"likes_avg":{"value":666261},"subscribers_count":{"value":10807423},"real_subscribers_count":null,"er":{"value":6.170528,"mark":"good"},"subscribers_growth_prc":null},"total_subscribers":10807423}]);
      //   this.loading_service_results = false;
      //   return; 
      // } 
      // --------------------------------------------------

      const data = {
        network: this.network_selected.src,
        username: this.user_selected.username,
      }
      searcher_services.freeLookalikeSearcher(data).then((response) => {
        if (response.status === 200 && !response.data.error) {
          this.data_table = this.formatDataTable(response.data.accounts);
          this.loading_service_results = false;
        } else if (response.data.error) {
          this.loading_service_results = false;
          toast_notification().then((toast) => {
            this.$toast({
              component: toast.default,
              position: 'top-right',
              props: {
                title: 'Error',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                text: 'Lo sentimos, no podemos obtener los datos en este momento.'
              }
            })
          })
        }
      })
    },
    redirectInnerNet(username) {
      window.open(`${this.local}/perfil/instagram/${username}`, '_blank')
    },
    getCategories() {
      searcher_services.getCategories(this.network_selected.value).then(response => {
        this.total_categories_service = response;
      })
    },
    getCategoriesLabel(array_categories) {
      
      if (this.total_categories_service) {
        const new_m = array_categories.map((index_category) => {
          for (const key in this.total_categories_service) {
            if (this.total_categories_service[key].find(i => i.id === index_category))
              return this.total_categories_service[key].find(i => i.id === index_category).title
          }
        })
        return {all_categories: new_m, first_category: new_m[0]};
      }
      return {all_categories: [], first_category: ''};
      
    },
  },
  watch: {
    network_selected() {
      this.inputProps.placeholder = this.network_selected.src === 'yt' ? 'Introduce el canal de YouTube' : `Introduce una cuenta de ${this.network_selected.text}`
      this.user = '';
      this.user_selected = null;
      this.typingTimer = setTimeout(this.getResultsSuggestion, 300);
      this.getCategories()
    }
  }
}
</script>

<style lang="scss" scoped>
.h-52 {
  height: 52px;
}
.w-1200 {
  max-width: 1200px;
}
.mb-03 {
  margin-bottom: 0.3em;
}
.ml-05 {
  margin-left: 0.2em;
}
.size-16-icons {
  width: 16px;
  height: 16px;
  margin-right: 0.3em;
}
.text-muted-username {
  color: #8490A4;
  font-size: 14px;
  font-family: 'avenir-medium';
}
.avatar-categories {
  width: 200px;
  text-overflow: ellipsis;
  background-color: #fcfcfc;
  border: 1px solid #E7E8E8;
  font-family: 'avenir-medium';
  padding: 0.2em 0.9em;
  border-radius: 20px;
  position: absolute;
  top: 0;
  left: 0;
  white-space: nowrap;
  overflow-x: hidden;
}
.loading-suggestioner-input {
  position: absolute; 
  right: 10px; 
  top: 5px;
}
.x-suggestioner-input {
  position: absolute; 
  right: 10px; 
  top: 13px;
  cursor: pointer;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-autosuggest.scss';

.body-button-center {
  
  position: relative;
  background-color: #e9ecef;
  padding: .25rem .25rem;
  border-radius: .375rem;
  .button-outline-header-grid-active {
    background: white;
    padding: 5px 10px;
    border-radius: 6px !important;
  }

  .button-outline-header-grid-no-active {
    background: transparent;
    padding: 5px 10px;
    border: none;
  }
  @media(max-width: 350px) {
    display: flex;
    flex-wrap: wrap;
  }
}

.thead-light th {
  background-color: transparent !important;
}
.table-responsive {
  border: 1px solid #d8d6de;
}
#table-searcher-free-tool {
  padding: 0.2em;
  width: 100%;
  background-color: transparent;
  td {
    padding: 11px 16px;
  }
  tr {
    background-color: white;
  
    &:hover {
      .size-18-icons {
        visibility: visible;
      }
    }
  }
  tbody {
    td:nth-child(4) {
      min-width: 260px !important;
    }
    tr:last-child {
      filter: blur(3px)
    }
  }
}
</style>